"use client";

import type { HeatmapEntryOverride } from "@multi-tenant-cms/types";
import { useEffect } from "react";
import {
	HEATMAP_PAGE_CONTEXT_KEY,
	type HeatmapPageWindowContext,
} from "@/lib/heatmap";

type HeatmapWindow = Window & {
	[HEATMAP_PAGE_CONTEXT_KEY]?: HeatmapPageWindowContext;
};

type Props = {
	entryId: string;
	override: HeatmapEntryOverride;
};

export function HeatmapPageScope({ entryId, override }: Props) {
	useEffect(() => {
		const heatmapWindow = window as HeatmapWindow;
		heatmapWindow[HEATMAP_PAGE_CONTEXT_KEY] = {
			entry_id: entryId,
			override,
		};
		return () => {
			if (heatmapWindow[HEATMAP_PAGE_CONTEXT_KEY]?.entry_id === entryId) {
				heatmapWindow[HEATMAP_PAGE_CONTEXT_KEY] = undefined;
			}
		};
	}, [entryId, override]);

	return null;
}
